import {
  ADD_CONTRACTOR,
  DELETE_CONTRACTOR,
  GET_CONTRACTOR_PROFILE,
  GET_CONTRACTORS_LIST,
  HIDE_CONTRACTOR_LIST_LOADER,
  SET_CONTRACTOR_PROFILE,
  SET_CONTRACTORS_LIST,
  SET_ERROR_CONTRACTOR_PROFILE,
  SHOW_CONTRACTOR_LIST_LOADER,
  UPDATE_CONTRACTOR_PROFILE,
  CONTRACTOR_PROFILE_LOADER,
} from "./actionTypes";

export const getContractorsList = data => ({
  type: GET_CONTRACTORS_LIST,
  payload: data,
});

export const setContractorsList = payload => ({
  type: SET_CONTRACTORS_LIST,
  payload,
});

export const showContractorsListLoader = () => ({
  type: SHOW_CONTRACTOR_LIST_LOADER,
});

export const hideContractorsListLoader = () => ({
  type: HIDE_CONTRACTOR_LIST_LOADER,
});

export const addContractor = (contractor = {}, data = {}) => ({
  type: ADD_CONTRACTOR,
  payload: { contractor, data },
});

export const deleteContractor = (id, data = {}) => ({
  type: DELETE_CONTRACTOR,
  payload: { id, data },
});

export const getContractorProfile = id => ({
  type: GET_CONTRACTOR_PROFILE,
  payload: id,
});

export const setContractorProfile = payload => ({
  type: SET_CONTRACTOR_PROFILE,
  payload,
});

export const updateContractorProfile = (id, contractor = {}, data = {}) => ({
  type: UPDATE_CONTRACTOR_PROFILE,
  payload: { id, contractor, data },
});

export const setErrorContractorProfile = payload => ({
  type: SET_ERROR_CONTRACTOR_PROFILE,
  payload,
});

export const setContractorProfileLoader = () => ({
  type: CONTRACTOR_PROFILE_LOADER,
});
